import { createAction } from '@reduxjs/toolkit';

const setAutoPromoCode = createAction('promo_code/auto/set');
const setPromoCodes = createAction('promo_codes/list/set');

export { setPromoCodes, setAutoPromoCode };
